export default __webpack_public_path__ + "static/media/plate.db335af5.svg";